import { useState } from 'react';

import styled from '@emotion/styled';
import { Trans } from '@lingui/react/macro';
import { ArrowDownward, Print } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useAtomValue } from 'jotai';
import { useParams } from 'react-router';

import { selectedVisitAtom } from '../../../../app/appHeader/imageViewerMenu/atoms';
import { blueBlack400, green400 } from '../../../../theme/videa-style-tokens';
import type { EventName } from '../../../../utils/mixpanel';
import { mixpanelEvents, useTrackEvent } from '../../../../utils/mixpanel';
import { useGetCurrentImage } from '../../multiFileViewer/findingViewer/imageBrowser/helpers';
import { selectedFindingsAtom } from '../atoms';

import { DeprecatedPreviewDialog } from './DeprecatedPreviewDialog';

const StyleWrapper = styled.div`
  .toolbar-export-options {
    display: flex;
  }
  .print-option,
  .download-option {
    background-color: ${green400};
    color: white;
    padding: 0.5em 1em;
    text-transform: none;
    :hover {
      background-color: ${blueBlack400};
    }
  }
  .print-option {
    margin-right: 4px;
  }
`;

export type DownloadOption = 'print' | 'download';

export const DownloadOptions = () => {
  const selectedImages = useGetCurrentImage();
  const currentImage = selectedImages?.currentImage;
  const selectedPhoto = selectedImages?.selectedPhoto;
  const { id: selectedPatientId } = useParams<{
    id: string;
  }>();

  const [selectedOption, setSelectedOption] = useState<DownloadOption>();
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const estimatedVisitId = useAtomValue(selectedVisitAtom);
  const casePresentationMode = useAtomValue(selectedFindingsAtom)
    ? 'single finding'
    : 'present all';

  const { trackEvent } = useTrackEvent();

  const handleTrackEvent = (eventName: EventName, mode: DownloadOption) => {
    const currentImageType = currentImage
      ? currentImage?.detectedImageType === 'COLOR_IMAGE'
        ? 'DENTAL_PHOTO'
        : 'X-RAY'
      : undefined;
    const selectedPhotoType = selectedPhoto
      ? selectedPhoto?.detectedImageType === 'COLOR_IMAGE'
        ? 'DENTAL_PHOTO'
        : 'X-RAY'
      : undefined;

    trackEvent(eventName, {
      source: casePresentationMode,
      mode,
      estimatedVisitId: estimatedVisitId,
      image: [currentImage?.imageId, selectedPhoto?.imageId].filter(Boolean),
      patientId: selectedPatientId,
      imageTypes: [currentImageType, selectedPhotoType].filter(Boolean),
    });
  };

  return (
    <StyleWrapper>
      <div className="toolbar-export-options">
        <Button
          className="print-option"
          
          onClick={() => {
            setIsPreviewOpen(true);
            setSelectedOption('print');
            handleTrackEvent(
              mixpanelEvents.casePresentationSuggestionPreview,
              'print',
            );
          }}
          startIcon={<Print />}
        >
          <Trans>Print</Trans>
        </Button>
        <Button
          className="download-option"
          
          onClick={() => {
            setIsPreviewOpen(true);
            setSelectedOption('download');
            handleTrackEvent(
              mixpanelEvents.casePresentationSuggestionPreview,
              'download',
            );
          }}
          startIcon={<ArrowDownward />}
        >
          <Trans>Download</Trans>
        </Button>
      </div>
      (
      <DeprecatedPreviewDialog
        isPreviewOpen={isPreviewOpen}
        setIsPreviewOpen={setIsPreviewOpen}
        selectedPatientId={selectedPatientId}
        selectedOption={selectedOption}
        handleTrackEvent={handleTrackEvent}
      />
      )
    </StyleWrapper>
  );
};
